import axios from 'axios'// 引入axios
import env from '../http/env'
import router from '../router'
import Vue from 'vue'
import { Promise } from 'core-js'
import qs from 'qs'
// application/json;charset=UTF-8;
// 创建axios实例
const service = axios.create({
  // 这里拿线上接口测试
  baseURL: env.baseIP,
  headers: { // 请求头
    'Content-Type': 'application/json;charset=UTF-8;'
  },
  settimeout: 6000 // 超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // console.log(config)
    /**
     * isPhp: 调用php接口，使用phptoken
     * isScreen: 大屏请求接口
     * isPhpFtalk：php后台接口
     */
    if (config.isPhp) {
      config.baseURL = env.AIBaseIP
    } else if (config.isScreen) {
      config.baseURL = env.screenIP
    } else if (config.isPhpFtalk) {
      config.baseURL = env.pczxBaseIP
    } else if (config.isPczxIP) {
      config.baseURL = env.pczxIP
    } else {
      config.headers.Terminal = 'WEB'
    }
    // Vue.$showLoading.show()
    if (config.isPhp || config.isScreen || config.isPhpFtalk) {
      config.headers.Authorization = localStorage.getItem('phpToken')
    } else {
      if (localStorage.getItem('Authorization')) {
        config.headers.Authorization = localStorage.getItem('Authorization')
      }
    }
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config // 记得一定要 返回config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use((res) => {
  const locale = localStorage.getItem('locale')
  // console.log('locale=================', locale)
  if (!localStorage.getItem('locale')) {
    localStorage.setItem('locale', 'ZH')
  }
  if (res.status && res.status === 200) {
    if (res.headers && res.headers.authorization) {
      const authorization = res.headers.authorization
      localStorage.setItem('Authorization', authorization)
    }
    if (res.data.code === 200) {
      return res.data
    } else if (res.data.code === 2014) { // 有未完善的资料
      const titleStr1 = locale === 'ZH' ? '您有未完善的信息，是否现在去完善?' : 'You have incomplete information, do you want to improve it now'
      const titleStr2 = locale === 'ZH' ? '提示' : 'Tips'
      const titleStr3 = locale === 'ZH' ? '去完善' : 'To improve'
      const titleStr4 = locale === 'ZH' ? '取消' : 'cancel'
      Vue.prototype.$confirm(titleStr1, titleStr2, {
        confirmButtonText: titleStr3,
        cancelButtonText: titleStr4,
        type: 'warning',
        center: true
      }).then(() => {
        router.push({
          path: '/chnEngRegist'
        })
      }).catch(() => {
      })
    } else if (res.data.code === 6001 || res.data.code === 8006 || res.data.code === 466) {
      // 6001:启用学习计划，无单词
      // 8006:pczx添加老师接口，已存在
      // 466:裁判系统第二赛段切换选手，查询到上一个考生正在作答
      return res.data
    } else if (res.data.code === 401) {
      const titleStr5 = locale === 'ZH' ? '登录已过期，请重新登录！' : 'Login has expired, please login again!'
      Vue.prototype.$message.error(titleStr5)
      router.push({
        path: '/homeIndex',
        params: {
          pushUrl: ''
        }
      })
    } else {
      Vue.prototype.$message.error(res.data.msg)
    }
    const businessError = new Error(res.data.msg || 'Request failed')
    businessError.response = res
    businessError.data = res.data
    return Promise.reject(businessError)
  }
}, err => {
  Vue.$showLoading.hide()
  const locale = localStorage.getItem('locale')
  const titleStr6 = locale === 'ZH' ? '登录已过期，请重新登录！' : 'Login has expired, please login again!'
  const titleStr7 = locale === 'ZH' ? '无服务，请稍后重试！' : 'No service, please try again later!'
  console.log('err', err)
  if (err.code === 'ERR_BAD_RESPONSE') {
    if (err.response.data.code === 401) {
      Vue.prototype.$message.error(titleStr6)
      router.push({
        path: '/homeIndex',
        params: {
          pushUrl: ''
        }
      })
    } else {
      Vue.prototype.$message.error(titleStr7)
    }
  } else {
    if (err.status === 401) {
      Vue.prototype.$message.error(titleStr6)
      router.push({
        path: '/homeIndex',
        params: {
          pushUrl: ''
        }
      })
    } else {
      Vue.prototype.$message.error(titleStr7)
    }
  }
  return Promise.reject(err)
})
export default service
